/**
 * add-to-calendar-button 的繁體中文文案
 * 套件內建的 zh 是簡體，結構照 node_modules/add-to-calendar-button/dist/locales/zh.json 翻譯；
 * 最後幾個 key 覆寫行事曆名稱的顯示文字，一律用消費者看得懂的說法：
 * 不寫「.ics」，Microsoft 365 / Outlook.com 改用帳號類型區分
 */
export default {
  label: {
    addtocalendar: '加入行事曆',
    share: {
      email: '透過 Email 分享',
      copy: '複製連結',
      copied: '已複製',
      email_subject: '記下這個日期',
    },
    rsvp: {
      title: 'RSVP',
      expired: '已過期',
      bookedout: '已額滿',
      restart: '重新回覆',
    },
  },
  // 只出現在 Android 的「使用其他行事曆」：下載 .ics 後由手機選擇用哪個行事曆 App 開啟
  ical: '手機內建行事曆（Samsung 等）',
  modal: {
    button: {
      default: '點我',
    },
    webview: {
      ical: {
        h: '請用瀏覽器開啟',
        text: 'App 內建的瀏覽器無法加入行事曆。',
        steps: '<ol><li>打開手機上的 Safari 或 Chrome</li><li>貼上剛剛複製的連結並前往</li></ol>',
      },
    },
    clipboard: {
      text: '已自動複製連結。',
      failed: '無法自動複製，請手動複製以下連結：',
    },
    opensafari: {
      ical: {
        h: '請用 Safari 開啟',
        text: 'iPhone 只有 Safari 能直接加入行事曆。',
        steps: '<ol><li><strong>打開 Safari</strong></li><li>貼上剛剛複製的連結並前往</li></ol>',
      },
    },
    multidate: {
      h: '這是系列活動',
      text: '請逐一加入：',
    },
  },
  date: {
    status: {
      cancelled: '這個預約已取消。',
      cancelled_cta: '請更新您的行事曆！',
    },
  },
  group_overview: {
    empty: '今年沒有活動。',
  },
  close: '關閉',
  continue: '繼續',
  cancel: '取消',
  expired: '已過期',
  recurring: '重複',
  thankyou: '謝謝',
  submit: '送出',
  form: {
    error: {
      required: '還有必填欄位沒有填寫',
      sending: '送出時發生問題，請稍後再試',
      email: 'Email 格式不正確',
      bookedoutmany: '名額不足，請減少人數',
    },
    success: {
      title: '已送出！',
      sent: '已收到您的回覆，謝謝！',
      email: '確認信已寄到您的信箱。',
      doi: '請在 30 分鐘內點擊確認信中的連結，回覆才會生效。',
      demo: '謝謝，RSVP 示範到此結束。',
      already: '您已經回覆過了。',
    },
    status: {
      title: '您會參加嗎？',
      confirmed: '會',
      undecided: '不確定',
      declined: '不會',
    },
    amount: '人數',
    max: '上限',
    email: 'Email',
    seatsleft: '剩餘名額',
  },
  apple: 'Apple 行事曆',
  google: 'Google 日曆',
  ms365: 'Outlook（公司／學校帳號）',
  outlookcom: 'Outlook（個人帳號）',
};
